<template>
  <div id="lott">
    <div class="nr">
      <CompMenu />
      <div class="center">
        <div class="tit">
          <h2>{{ this.menu | transMenuName(this.menuType) }}</h2>
        </div>
        <CompMarquee />
        <div class="list">
          <div class="fx">
            <div class="hid">
              <select v-model="intCoinType" v-on:change="getLottList">
                <option value="">全部幣別</option>
                <option value="D">希望幣</option>
                <option value="G">金幣</option>
                <option value="S">銀幣</option>
                <option value="C">銅幣</option>
              </select>
              <ul class="slides">
                <li
                  :class="{ fst: true, on: mainTypeId == '' }"
                  @click="mainTypeId = ''"
                >
                  <router-link :to="{ name: 'lottList', params: { id: 0 } }"
                    >全部</router-link
                  >
                </li>
                <li
                  v-for="(item, index) in typeList"
                  :key="index"
                  :class="{
                    brn: index == typeList.length - 1,
                    on: item.id == mainTypeId,
                  }"
                >
                  <router-link
                    :to="{ name: 'lottList', params: { id: item.id } }"
                    >{{ item.name }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="search">
            <div style="width: 40%">
              <select v-model="subtypeId">
                <option value="">全部</option>
                <option
                  v-for="(item, index) in subtypeList"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div style="width: 50%">
              <input
                type="text"
                placeholder="搜尋產品"
                v-model.trim="searchName"
              />
              <span class="btn btn-warning" @click="search()">搜尋</span>
            </div>
          </div>
          <CompLottItem :lottList="lottList" />
          <CompPager
            @evtpagerchg="vodGetPage"
            :int-per-page="page.pagesize"
            :int-tol-cnt="pageData.allnums"
            :int-cur-page="page.currentPage"
            ref="pager"
          ></CompPager>
        </div>
      </div>
      <CompFoot/>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    CompMenu: require("@/components/parts/CompMenu").default,
    CompMarquee: require("@/components/parts/Marquee").default,
    CompPager: require("@/components/parts/pager").default,
    CompLottItem: require("@/components/LottItem").default,
    CompFoot: require("@/components/parts/Foot").default,
  },
  computed: {
    ...mapState({
      typeList: (state) => state.product.typeList,
      pageData: (state) => state.app.pageData,
      subtypeList: (state) => state.product.subtypeList,
      lottList: (state) => state.activity.lottList,
      menu: (state) => state.website.menu,
    }),
    ...mapGetters({
      loginState: "loginState",
      webMode: "webMode",
    }),
  },
  data() {
    const initPage = { pagesize: 16, currentPage: 1 };
    return {
      initPage,
      page: Object.assign({}, initPage),
      mainTypeId: "",
      searchName: "",
      subtypeId: "",
      intCoinType: "",
      menuType: "lott",
    };
  },
  watch: {
    mainTypeId: async function (id) {
      this.page = { pagesize: 16, currentPage: 1 };
      this.subtypeId = "";
      this.searchName = "";
      this.getLottList();
      this.getsubtype(id);
    },
    subtypeId: async function (id) {
      this.page = { pagesize: 16, currentPage: 1 };
      this.searchName = "";
      this.getLottList();
    },
  },
  methods: {
    vodGetPage(page) {
      this.page.currentPage = page;
      this.getLottList();
    },
    search() {
      if (this.searchName == "") {
        this.$snotify.error("請輸入搜尋關鍵字");
        return;
      }
      this.page = { pagesize: 16, currentPage: 1 };
      this.subtypeId = "";
      this.getLottList();
    },
    async getLottList() {
      const data = {
        page: this.page.currentPage,
        pagesize: this.page.pagesize,
        maintype: this.mainTypeId,
        subtype: this.subtypeId || undefined,
        name: this.searchName,
        coin: this.intCoinType,
      };
      await this.$store.dispatch("activity/getLottList", data);
    },
    async getType() {
      await this.$store.dispatch("product/getType");
    },
    async getsubtype(maintype) {
      const data = {
        maintype,
      };
      await this.$store.dispatch("product/getsubtype", data);
    },
  },
  async created() {
    await this.getType();
    await this.getLottList();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.mainTypeId = Number(to.params.id);
    } else {
      this.mainTypeId = "";
    }
  },
};
</script>
<style>
@import "~@/assets/css/lott.css";
</style>
